import React from 'react';
import CloseButton from '../CloseButton/closeButton';
import { ScrollType } from '../modal.types';
import { ModalContentContainer, ModalContentScrollContainer } from './modalContent.style';
import { ModalContentProps } from './modalContent.types';

const DEFAULT_DATA_ATTR = { 'data-testid': 'modal__content-container' };

const ModalContent = ({
  children,
  CloseButtonComponent = CloseButton,
  closeButtonProps,
  contentRef,
  dataAttr = {},
  hideCloseButton = false,
  scrollType,
  ...props
}: ModalContentProps) => {
  const combinedDataAttr = { ...DEFAULT_DATA_ATTR, ...dataAttr };

  /**
   * An extra container is added for ScrollType.CONTENT
   * This is necessary to accommodate the close button, because otherwise it would be hidden by the overflow styling
   */
  const renderChildren = () => {
    if (scrollType === ScrollType.CONTENT) {
      return <ModalContentScrollContainer>{children}</ModalContentScrollContainer>;
    }
    return children;
  };

  return (
    <ModalContentContainer
      {...props}
      {...combinedDataAttr}
      hideCloseButton={hideCloseButton}
      ref={contentRef}
      scrollType={scrollType}
    >
      {!hideCloseButton && <CloseButtonComponent {...closeButtonProps} />}
      {renderChildren()}
    </ModalContentContainer>
  );
};

export default React.memo(ModalContent);
